import { z } from "zod";

// ADV-799: aggregate snapshot for the Today page's Commission Snapshot section.
// Per-status sums + the current pay period window. The detail-row API is
// CommissionSchema; this shape is purely the aggregate envelope.

export const CommissionSummarySchema = z.object({
  pay_period_start: z.string().nullable().describe("Pay Period Start"),
  pay_period_end: z.string().nullable().describe("Pay Period End"),
  pay_date: z.string().nullable().describe("Pay Date"),
  pending_amount: z.number().describe("Pending Amount"),
  payable_amount: z.number().describe("Payable Amount"),
  paid_amount: z.number().describe("Paid Amount"),
  total_amount: z.number().describe("Total Amount"),
  count: z.number().int().describe("Count"),
});
export type CommissionSummary = z.infer<typeof CommissionSummarySchema>;
